import React, { useState } from "react";

export const CITIES = [
  "Mumbai","Delhi","Bangalore","Hyderabad","Chennai","Kolkata",
  "Pune","Ahmedabad","Jaipur","Surat","Lucknow","Kanpur",
  "Nagpur","Indore","Thane","Bhopal","Visakhapatnam","Noida",
  "Gurugram","Faridabad","Ghaziabad","Patna","Vadodara","Ludhiana",
];

export const labelSt: React.CSSProperties = {
  fontSize:13, fontWeight:600, color:"var(--text)", marginBottom:7, display:"block",
};
export const errSt: React.CSSProperties = {
  fontSize:12, color:"var(--danger)", marginTop:5,
};

export function FormField({ label, error, children }: { label: string; error?: string; children: React.ReactNode }) {
  return (
    <div>
      <label style={labelSt}>{label}</label>
      {children}
      {error && <p style={errSt}>⚠ {error}</p>}
    </div>
  );
}

interface TextInputProps {
  value: string;
  onChange?: (v: string) => void;
  placeholder?: string;
  mode?: string;
  error?: string;
  readOnly?: boolean;
  maxLength?: number;
}

export function TextInput({ value, onChange, placeholder, mode, error, readOnly, maxLength }: TextInputProps) {
  const [focus, setFocus] = useState(false);
  return (
    <input
      value={value}
      readOnly={readOnly}
      inputMode={mode as any}
      placeholder={placeholder}
      maxLength={maxLength}
      onChange={e => onChange?.(e.target.value)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      style={{
        width:"100%", background:readOnly?"var(--surface2)":"#fff",
        border:`1.5px solid ${error?"var(--danger)":focus?"var(--indigo)":"var(--border)"}`,
        borderRadius:11, padding:"12px 14px", fontSize:14, color:"var(--text)",
        fontFamily:"var(--font-body)", outline:"none",
        transition:"border-color 0.18s, box-shadow 0.18s",
        boxShadow:focus&&!error?"0 0 0 3px rgba(79,70,229,0.1)":"none",
        boxSizing:"border-box",
      }}
    />
  );
}

interface TextareaInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  rows?: number;
  error?: string;
}

export function TextareaInput({ value, onChange, placeholder, rows = 2, error }: TextareaInputProps) {
  const [focus, setFocus] = useState(false);
  return (
    <textarea
      value={value}
      rows={rows}
      placeholder={placeholder}
      onChange={e => onChange(e.target.value)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      style={{
        width:"100%", background:"#fff",
        border:`1.5px solid ${error?"var(--danger)":focus?"var(--indigo)":"var(--border)"}`,
        borderRadius:11, padding:"12px 14px", fontSize:14, color:"var(--text)",
        fontFamily:"var(--font-body)", outline:"none", resize:"none", lineHeight:1.5,
        transition:"border-color 0.18s, box-shadow 0.18s",
        boxShadow:focus&&!error?"0 0 0 3px rgba(79,70,229,0.1)":"none",
        boxSizing:"border-box",
      }}
    />
  );
}

interface CitySelectProps {
  value: string;
  onChange: (v: string) => void;
  error?: string;
}

export function CitySelect({ value, onChange, error }: CitySelectProps) {
  const [focus, setFocus] = useState(false);
  return (
    <div style={{ position:"relative" }}>
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        style={{
          width:"100%", background:"#fff",
          border:`1.5px solid ${error?"var(--danger)":focus?"var(--indigo)":"var(--border)"}`,
          borderRadius:11, padding:"12px 36px 12px 14px", fontSize:14,
          color:value?"var(--text)":"var(--text3)",
          fontFamily:"var(--font-body)", outline:"none",
          appearance:"none", WebkitAppearance:"none",
          transition:"border-color 0.18s, box-shadow 0.18s",
          boxShadow:focus&&!error?"0 0 0 3px rgba(79,70,229,0.1)":"none",
          cursor:"pointer", boxSizing:"border-box",
        }}>
        <option value="">Select city</option>
        {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      <svg style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", pointerEvents:"none" }}
        width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--text3)" strokeWidth="2.5" strokeLinecap="round">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </div>
  );
}
